import styled from 'styled-components';
import IndoorSvg from '../../assets/amenities/indoor.svg';

const IndoorIcon = styled(IndoorSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default IndoorIcon;
